import { dark } from '@/scss/themes/dark'
import { light } from '@/scss/themes/light'
import MomentAdapter from '@date-io/moment'
import { createVuetify } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa'
import { mdi } from 'vuetify/iconsets/mdi'

export default createVuetify({
    date: {
        adapter: MomentAdapter
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            fa,
            mdi
        }
    },
    theme: {
        defaultTheme: 'dark',
        themes: {
            light,
            dark
        }
    }
})
